import styled from '@emotion/styled';

const zoomInIcon = (color: string) =>
  `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg"><path d="M8 2.75V13.25M2.75 8H13.25" stroke="${encodeURIComponent(color)}" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/></svg>')`;

const zoomOutIcon = (color: string) =>
  `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg"><path d="M3.75 9H14.25" stroke="${encodeURIComponent(color)}" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/></svg>')`;

const popupArrow = () =>
  `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg"><path d="M 25.9808 11.4407 L 0 0 L 51.9616 0 L 25.9808 11.4407 Z" fill="${encodeURIComponent('#FFFFFF')}" stroke="${encodeURIComponent('#FFFFFF')}"/></svg>')`;

export const AzureMapStyleWrapper = styled.div`
  height: 100%;

  .popup-content-container {
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.25);
  }

  .popup-arrow {
    width: 3.25rem  
    height: 0.75rem  
    background-image: ${popupArrow()}  
    filter: drop-shadow(0 12px 12px rgba(0, 0, 0, 0.25));
    border: none;
    transform: translateY(-1px);
  }

  .azure-maps-control-button {
    background-color: #f5f5f5  
    box-shadow: rgba(0, 0, 0, 0.25) 0px 4px 4px  
    border-radius: 50%  
    margin: 5px  

    &.zoom-in {
      background-size: 16px 16px  
      background-image: ${zoomInIcon('#DC143C')}  
      position: relative  

      &:hover {
        background-image: ${zoomInIcon('#000000')}  
      }
    }

    &.zoom-out {
      background-size: 18px 18px  
      background-image: ${zoomOutIcon('#DC143C')}  

      &:hover {
        background-image: ${zoomOutIcon('#000000')}  
      }
    }
  }
`;
